var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-header btn-light w-100"},[_c('i',{staticClass:"far fa-window-restore mr-2"}),_c('span',[_vm._v("Header")])]),_c('div',{staticClass:"component-content"},[_c('div',{staticClass:"page-title"})])])
}]

export { render, staticRenderFns }